<template>
  <v-card  v-if="userDetails.Allows.AddIssues" :loading="loading">
    <v-card-title>
      Ανοιχτά αιτήματα
      <v-icon v-tooltip="'Για οποιαδήποτε ανάγκη έχετε μπορείτε να αποστείλετε ένα αίτημα στο γραφείο ανελκυστήρων.' +
                             ' Το γραφείο θα ενημερωθεί εγκαίρως και θα σας απαντήσει.'"> mdi-help-circle-outline
      </v-icon>
    </v-card-title>
    <v-card-text class="pb-0" v-if="!hideButtons">
      Για οτιδήποτε αίτημα έχετε προς τo γραφείο.
    </v-card-text>
    <v-list>
      <issue-item @click="goToIssue(i)" v-for="i in openIssues" :item="i"/>
    </v-list>
    <v-card-text v-if="!hideButtons">
      <v-btn color="secondary" to="/addIssue" dark> ΝΕΟ ΑΙΤΗΜΑ</v-btn>
      <v-btn text color="primary" to="/issues"> ΟΛΑ</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import IssueItem from "@/views/Issues/components/IssueListItem";

export default {
  name: "OpenIssues",
  components: {IssueItem},
  props: {
    loading: Boolean, maxHeight: {type: String, default: null, required: false},
    hideButtons: {type: Boolean, default: false, required: false}

  },
  computed: {
    ...mapGetters([
      'userDetails',
      "openIssues",
    ])
  },
  methods: {
    goToIssue(issue) {
      this.$router.push({path: '/issues', query: {id: issue.Issue_ID}});
    }
  },

}
</script>

<style scoped>

</style>
